import { Map } from 'immutable';
import {
  GET_TAXES_SUCCESS,
  GET_TAXED_LOCATIONS_SUCCESS,
  GET_TAXED_PRODUCTS_SUCCESS,
  GET_TAXED_CATEGORIES_SUCCESS,
} from './TaxesActionTypes';

const initialState = Map({
  taxList: [],
  taxedLocations: [],
  taxedCategories: [],
  taxedProducts: [],
});

export default function TaxesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TAXES_SUCCESS:
      return state.set('taxList', action.response);
    case GET_TAXED_LOCATIONS_SUCCESS:
      return state.set('taxedLocations', action.response);
    case GET_TAXED_PRODUCTS_SUCCESS:
      return state.set('taxedProducts', action.response);
    case GET_TAXED_CATEGORIES_SUCCESS:
      return state.set('taxedCategories', action.response);
    default:
      return state;
  }
}
